import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowTrendUp = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 13L8 6.99995L14 12.9999L22 5L21.7665 5.23348", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M16 5H22V11", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M2 20H22", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconArrowTrendUp.js.map